import FileUpload from 'components/fileUpload';
import FileUploadService from 'services/FileUploadService';

const fileUploadServiceObj = new FileUploadService();

export default function ResourceTab(props) {
  const { labId, labDetails } = props;

  return (
    <FileUpload
      labId={labId}
      labDetails={labDetails}
    />
  )
}